@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../constants/spacing.module.less';

.right-aligned-container {
  display: flex;
  align-items: center;
}

.date-range-dropdown-wrapper,
.store-dropdown-wrapper {
  display: flex;
  height: 32px;
  margin-left: 24px;
  align-items: center;
  font-size: 14px;
  background-color: inherit;
}

.store-dropdown-toggler {
  flex: 3;
  border: 1px solid @insights-page--store-dropdown--border-color;
  border-radius: 5px;
  align-items: center;
  height: 32px;
  background-color: @insights-page--store-dropdown--background-color;
}

.dropdown-label {
  text-align: right;
  padding-right: 15px;
  flex: 1;
  white-space: nowrap;
}

.store-dropdown,
.date-range-dropdown {
  flex: 3;
  min-width: 200px;
}

.unavailable-header {
  font-size: 20px;
  line-height: 1.25;
  padding-bottom: 15px;
}

.unavailable-message {
  font-size: 14px;
  line-height: 1.5;
  width: 600px;
}

.filter-bar-wrapper {
  display: flex;
  flex-direction: column;
  gap: @space-4;
}

.filter-bar-label {
  display: block; /* ensure it takes full width */
  margin-bottom: @space-4;
  font-size: 14px;
  font-weight: 500;
  @line-height: @space-24;
}

.plan-features-trial-upsell-banner {
  margin-bottom: @space-16;
}
